import { render, staticRenderFns } from "./SeparatorBlock.vue?vue&type=template&id=3b88c716&"
import script from "./SeparatorBlock.vue?vue&type=script&lang=js&"
export * from "./SeparatorBlock.vue?vue&type=script&lang=js&"
import style0 from "./separator-block.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports